import {
  ContextualPrefetchType,
  PrefetchContextEnum,
  PrefetchQueryFnEnum,
  AnalyticsRoutesEnum,
} from 'interfaces'

/**
 * Prefetch policies, productivity, shadowIT, details
 * @param {prefetch} prefetch - contextual prefetch function from useContextualPrefetch
 * @returns {void}
 */
const prefetchAnalyticsSubPages = (
  prefetch: (args: ContextualPrefetchType) => void,
  emailId: string,
  options?: {skipProductivityPrefetch?: boolean},
): void => {
  const skipProductivityPrefetch = options?.skipProductivityPrefetch ?? false
  prefetch({
    route: AnalyticsRoutesEnum.ANALYTICS_OVERVIEW,
    context: PrefetchContextEnum.MOUNT,
    ...(skipProductivityPrefetch
      ? {
          skipQueryFnNames: [
            PrefetchQueryFnEnum.FETCH_ANALYTICS_PRODUCTIVITY_DATA,
            PrefetchQueryFnEnum.FETCH_ANALYTICS_PRODUCTIVITY_ACTIVITY_TIME_DATA,
          ],
        }
      : {}),
    payload: {
      [PrefetchQueryFnEnum.FETCH_ANALYTICS_POLICIES_TOP_BLOCKS_DATA]: {
        filter: {},
      },
      [PrefetchQueryFnEnum.FETCH_ANALYTICS_PRODUCTIVITY_DATA]: {
        params: {},
      },
      [PrefetchQueryFnEnum.FETCH_ANALYTICS_PRODUCTIVITY_ACTIVITY_TIME_DATA]: {
        activityByTimeFormat: 'Week',
        params: {},
      },
      [PrefetchQueryFnEnum.FETCH_ANALYTICS_SHADOW_IT_TOP_APPS_DATA]: {
        searchType: '',
        searchTerm: '',
      },
      [PrefetchQueryFnEnum.FETCH_ANALYTICS_SHADOW_IT_STREAM_CHARTS_DATA]: {
        shadowITView: 'application',
        shadowITSearchQuery: {
          searchType: '',
          searchTerm: '',
        },
      },
      [PrefetchQueryFnEnum.WARM_ANALYTICS_SEARCH]: {
        searchTerm: emailId,
      },
    },
  })
}

export default prefetchAnalyticsSubPages
